import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './immersiveNew.css';
const ImmersiveRoomAssessment = () => {
  const assessmentItems = [
    {
      id: 1,
      title: "Usage & Effectiveness",
      content: "Is it getting used enough? Are all your course subjects benefiting from the immersive space? Could all faculty subject leads see an opportunity to use it more effectively?"
    },
    {
      id: 2,
      title: "Content Development",
      content: "Since installation, have you been able to develop engaging content? Would you like access to new content, usage analytics, and student performance metrics? Are you interested in accessing third-party content in addition to bespoke content?"
    },
    {
      id: 3,
      title: "Start-Up Process",
      content: "Do your faculty find the system easy to use? Would you like the process to be more intuitive and user-friendly?"
    },
    {
      id: 4,
      title: "Touch Capabilities",
      content: "Are you satisfied with the current touch functionalities? Would you like to explore innovative technologies to enhance interaction and engagement?"
    }
  ];

  return (
    <div className=" py-5" style={{ background: 'linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%)' }}>
      <Container>
        <div className="text-center mb-5">
          <h2 className=" mxr__section-title mb-4 text-center">
            How well is your Immersive Room performing?
          </h2>
      
        </div>

        <Row className="g-4">
          {assessmentItems.map((item) => (
            <Col key={item.id} md={6}>
              <Card className="h-100 border-0 shadow-sm assessmentCard">
                <Card.Body className="d-flex gap-3">
                  <div className="number-circle bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center" 
                       style={{ width: '45px', height: '45px', minWidth: '45px', fontSize: '1.2rem', fontWeight: 'bold' }}>
                    {item.id}
                  </div>
                  <div>
                    <Card.Title className="h5 siteColor assessmentTitle mb-3">{item.title}</Card.Title>
                    <Card.Text className="text-muted">{item.content}</Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

    
    </div>
  );
};

export default ImmersiveRoomAssessment;